import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'

import store from '../store'

Vue.use(VueRouter)

const Router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes,
  mode: 'history',
  base: process.env.BASE_URL
})
const routesCustom = routes
const verifyUserIsLogged = () => store.getters['Login/isLoggedIn']
const verifyIfRoleExistInRolesRoute = (rolesRoute, role) => {
  for (const roleRoute of rolesRoute) {
    if (roleRoute === role) {
      return true
    }
  }
  return false
}
const verifyRolesToUser = (to, next, roles, routeReject) => {
  for (const role of roles) {
    if (to.matched.some(record => verifyIfRoleExistInRolesRoute(record.meta.roles, role))) {
      next()
      return
    }
    next(routeReject)
  }
}
const recoverRoles = () => {
  const data = JSON.parse(localStorage.getItem('data_travessia_webapp'))
  const roles = data === null ? ['all'] : data.role
  return roles
}
const verifyDashboardCorrect = (next) => {
  // console.log(next)
  return next.indexOf('dashboard-') !== -1
}
const returnSpecificDashboard = (roles) => {
  let dashboardSpecific = []
  for (const role of roles) {
    dashboardSpecific = routesCustom.filter(route => verifyDashboardCorrect(route.path) && verifyIfRoleExistInRolesRoute(route.meta.roles, role))
    if (dashboardSpecific.length !== 0) {
      return dashboardSpecific[0].path
    }
  }
}
Router.beforeEach((to, from, next) => {
  const roles = recoverRoles()
  const routeReject = returnSpecificDashboard(roles)
  verifyUserIsLogged() === true ? verifyRolesToUser(to, next, roles, routeReject) : verifyRolesToUser(to, next, roles, '/')
})

export default Router
